<template>
	<div class="pt-2">
		<CommonFlame :title="`${name} ${title}`">
			<div class="wrap mt-1">
				<a
					v-for="feature in featureList(id)"
					:key="feature.id"
					@click="
						$router.push({
							name: feature.name,
							params: { id: id, department_id: id },
						})
					"
					class="ma-5"
				>
					{{ feature.title }}
				</a>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../helper/authenticate"
import errorHandling from "../helper/errorHandling"
import CommonFlame from "./shared/CommonFlame.vue"

export default {
	components: {
		CommonFlame,
	},
	data() {
		return {
			title: "機能一覧",
			feature_list: [],
			departments: [],
			name: this.$route.query.name,
			id: this.$route.query.id,
		}
	},

	mounted() {
		this.fetchFeatures()
	},
	methods: {
		fetchFeatures() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/feature_lists", {
					headers,
				})
				.then((res) => {
					this.feature_list = res.data.feature_list
					this.featureList(this.id)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		featureList(department_id) {
			const matchedFeatures = []

			this.feature_list.forEach((feature) => {
				feature.departments.forEach((department) => {
					if (department.id == department_id) {
						matchedFeatures.push(feature)
					}
				})
			})
			return matchedFeatures
		},
	},

	watch: {
		"$route.query.id"(newId, oldId) {
			this.id = newId
			this.name = this.$route.query.name
		},
	},
}
</script>
<style lang="scss" scoped>
.wrap {
	display: flex;
	flex-wrap: wrap;
}
</style>
